var amdi18n={"__root":{"get_attribute_definitions_started":"Get attribute definitions started","get_attribute_definitions_succeeded":"Get attribute definitions succeeded","get_attribute_definitions_failed":"Get attribute definitions failed","invalid_attribute_definitions":"Invalid attribute definitions"}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;


//////////////////
// WEBPACK FOOTER
// ./node_modules/amdi18n-loader!./src/main/web/js/app/service/nls/AttributesManager_strings.js
// module id = 298
// module chunks = 4